import { useTranslation } from "react-i18next";

import { ActionIcon, Menu } from "@mantine/core";

import { useAuth } from "@/api/resources/auth/hooks";
import { useNavigation } from "@/hooks/useNavigation";
import { userName } from "@/utils/format";
import Icon from "@/utils/icons";

export const NavbarUserMenu = () => {
  const { t } = useTranslation();
  const { signOut, profile } = useAuth();
  const { goToLogin, goToAcademy, goToAccountSettings } = useNavigation();

  const handleSignOut = () => {
    signOut(undefined, {
      onSuccess: () => goToLogin(),
    });
  };

  return (
    <Menu width={260} position="bottom-end" transitionProps={{ transition: "pop-top-right" }} withinPortal>
      <Menu.Target>
        <ActionIcon variant="filled" size={60} p="sm" radius="xl">
          <Icon.USER_MENU size={60} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {profile && (
          <Menu.Item disabled>
            <b>{userName(profile)}</b>
            <br />
            <small>{profile.email}</small>
          </Menu.Item>
        )}

        <Menu.Item leftSection={<Icon.HELP />} onClick={goToAcademy}>
          {t("navigation.help")}
        </Menu.Item>

        <Menu.Item leftSection={<Icon.USER_SETTINGS />} onClick={goToAccountSettings}>
          {t("account-settings")}
        </Menu.Item>

        <Menu.Item leftSection={<Icon.LOGOUT />} onClick={handleSignOut}>
          {t("logout")}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default NavbarUserMenu;
